export default "<style>\n  #container {\n    width: 100%;\n  }\n</style>\n<div id=\"container\">\n  <slot></slot>\n</div>\n";